"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFilter = void 0;
var React = require("react");
var classNames = require("classnames");
var moment = require("moment");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var DatePicker_1 = require("components/DatePicker");
var Icon_1 = require("components/Icon");
require("./styles.scss");
var getInput = function (props) {
    switch (props.inputType) {
        case 'radiobutton': {
            if (props.options) {
                return props.options.map(function (option) { return (React.createElement(sok_ui_1.Button, { text: option.value, className: "list-button ".concat(props.textInputValue === option.key ? 'list-button-selected' : ''), type: 'submit', onClick: function () {
                        return props.textInputValue === option.key
                            ? props.setValue('')
                            : props.setValue(option.key);
                    } })); });
            }
            return;
        }
        case 'datetime':
        case 'day':
            return (React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('columnFilter/search'), parent: props.reference, closeOnSelect: true, dateFormat: 'L', selected: props.value || props.textInputValue
                    ? moment(props.value ? props.value : props.textInputValue, 'L')
                    : '', onChange: function (change) {
                    if (change) {
                        props.setValue(change.format('L'));
                    }
                } }));
        default:
            return (React.createElement(sok_ui_1.TextInput, { value: props.value === null ? props.textInputValue : props.value, placeholder: (0, translation_1.getLocalization)('columnFilter/search'), className: "white", autoFocus: true, onFocus: function (e) {
                    var val = e.target.value;
                    e.target.value = '';
                    e.target.value = val;
                }, onChange: function (e) {
                    return props.setValue(e.target.value.toString());
                }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }) }));
    }
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('isOpen', 'setIsOpen', false), (0, recompose_1.withState)('value', 'setValue', null), (0, recompose_1.withState)('reference', 'setReference', undefined), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.isOpen !== this.props.isOpen &&
            nextProps.isOpen === false) {
            nextProps.setValue(null);
        }
    }
}), recompose_1.pure);
var clearButton = function (props) { return (React.createElement(sok_ui_1.Button, { color: 'base-blue', text: (0, translation_1.getLocalization)('userfront/filelist/clearFilter'), disabled: !props.value && !props.textInputValue, onClick: function () {
        props.setIsOpen(false);
        props.setValue(null);
        props.clearColumnFilter(props.columnIdentifier);
    } })); };
exports.ColumnFilter = enhance(function (props) { return (React.createElement(sok_ui_1.Dropdown2, { className: classNames('column-filter-component', props.className), isOpen: props.isOpen, onChange: function (value, e) {
        var elem = e.target;
        while (elem) {
            if (elem.classList.contains('sok-dropdown2-menu') &&
                elem.classList.contains('sok-datepicker-menu')) {
                return;
            }
            elem = elem.parentElement;
        }
        if (props.isOpen === true) {
            if (e.target &&
                e.target.parentNode &&
                value !== props.isOpen) {
                return props.setIsOpen(value);
            }
            return;
        }
        props.setIsOpen(value);
    } },
    React.createElement(Icon_1.Icon, { className: classNames('fa-filter', props.className) }),
    React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sok-click-wall filter-dropdown' },
        React.createElement("div", { ref: props.setReference, className: "column-filter-component-menu" },
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                    if (props.value === '' ||
                        (props.value === null && props.textInputValue === '')) {
                        props.clearColumnFilter(props.columnIdentifier);
                    }
                    else {
                        props.setColumnFilterString(props.columnIdentifier, props.value === null ? props.textInputValue : props.value);
                        if (props.columnIdentifier && props.value) {
                            var filter = {};
                            filter[props.columnIdentifier] = props.value;
                            props.filterClick &&
                                props.filterClick(props.columnIdentifier, filter);
                        }
                    }
                    props.setIsOpen(false);
                    props.setValue(null);
                } }, props.inputType === 'radiobutton' ? (React.createElement("div", { className: "radio-buttons" },
                getInput(props),
                clearButton(props))) : (React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.ClickWall, null,
                    React.createElement("div", { className: "inputs" }, getInput(props))),
                React.createElement("div", { className: "buttons" },
                    clearButton(props),
                    React.createElement(sok_ui_1.Button, { color: 'base-green', text: 'OK', type: 'submit' }))))))))); });
